<template>
	<div class="course_bottomRight">
		<div class="course_title">课程作业</div>
		<div class="course_tabNormal">
			<div class="normal_filter">
				<span>作业状态：</span>
				<el-select :popper-append-to-body='false' v-model="state" @change='startsearch' placeholder="作业状态" clearable>
					<el-option :label="item.label" :value="item.value" :key="item.value" v-for='item in types'></el-option>
				</el-select>
			</div>
			<div class="normal_table">
				<el-table :data="taskList" border stripe>
					<emptymain slot="empty" :emptytext="'暂无作业'" :emptylist='taskList'></emptymain>
					<el-table-column prop="name" label="作业名称" align="center">
					</el-table-column>
					<el-table-column prop="topicNum" label="题目数量" width='120' align="center">
					</el-table-column>
					<el-table-column prop="sumScore" label="总分" align="center">
					</el-table-column>
					<el-table-column prop="passScore" label="及格分" align="center">
					</el-table-column>
					<el-table-column prop="endTime" label="提交截止日期" align="center">
						<template slot-scope="scope">
							{{scope.row.endTime | spliceForTask}}
						</template>
					</el-table-column>
					<el-table-column prop="createUsername" label="发布人" align="center">
					</el-table-column>
					<el-table-column prop="isFinish" label="当前状态" align="center">
						<template slot-scope="scope">
							<div class="task_status successColor" v-if='scope.row.isFinish'><img src="@/images/task_status1.png" />已提交</div>
							<div class="task_status infoColor" v-if='!scope.row.isFinish'><img src="@/images/task_status2.png" />未提交</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width='150' align="center">
						<template slot-scope="scope">
							<el-button size="mini" type="warning" :disabled="getDisabld(scope.row)" @click="startTask(scope.row)" v-if='!scope.row.isFinish'>写作业</el-button>
							<el-button size="mini" type="primary" @click="infoTask(scope.row)" v-if='scope.row.isFinish'>查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="taskPageChange" :current-page="taskPage" :page-size="limit" layout="  prev, pager, next, jumper" :total="tasktotalRow">
				</el-pagination>
			</div>
		</div>
		<el-dialog title="课堂作业" class="open_dialogInfo" :visible.sync="taskOpenIndex" :append-to-body='true' width="1000px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<task-index v-if='taskOpenIndex' :taskId='taskId' @taskOver='taskOver'></task-index>
		</el-dialog>
		<el-dialog title="课堂作业详情" class="open_dialogInfo" :visible.sync="taskOpenInfo" :append-to-body='true' width="1000px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<task-info v-if='taskOpenInfo' :taskId='taskId'></task-info>
		</el-dialog>
	</div>
</template>

<script>
	import { tasklist } from '@/api/task.js'
	import taskIndex from '@/views/courses/components/courseTaskIndex.vue'
	import taskInfo from '@/views/courses/components/courseTaskDetails.vue'
	export default {
		props: {
			courseId: String,
			chapterId: String,
			sectionId: String,
		},
		components: {
			taskIndex,
			taskInfo,
		},
		data() {
			return {
				state: '',
				limit: 10,
				taskPage: 1,
				tasktotalRow: 0,
				taskList: [],
				dataloading: false,
				types: [{
					value: '1',
					label: '已提交'
				}, {
					value: '2',
					label: '未提交'
				}],
				taskOpenInfo: false,
				taskOpenIndex: false,
				taskId: '',
			}
		},
		created() {
			this.getTaskList();
		},
		methods: {
			taskOver() {
				this.taskOpenIndex = false;
				this.taskId = '';
				this.state = '';
				this.startsearch();
			},
			getDisabld(item) {
				if(item.beginTime && item.endTime) {
					var nowTime = new Date();
					var beginTime = new Date(item.beginTime);
					var endTime = new Date(item.endTime);
					if(nowTime > beginTime && nowTime < endTime) {
						return false
					} else {
						return true
					}
				} else {
					return true
				}
			},
			startTask(item) {
				var nowTime = new Date();
				var beginTime = new Date(item.beginTime);
				var endTime = new Date(item.endTime);
				if(nowTime < beginTime) {
					this.$message({
						type: 'info',
						message: '作业时间未到！',
					})
					return;
				}
				if(nowTime > endTime) {
					this.$message({
						type: 'info',
						message: '作业时间已结束！',
					})
					return;
				}
				this.taskId = item.id;
				this.taskOpenIndex = true;
			},
			infoTask(item) {
				this.taskId = item.id;
				this.taskOpenInfo = true;
			},
			startsearch() {
				this.taskPage = 1;
				this.getTaskList()
			},
			taskPageChange(current) {
				this.taskPage = current;
				this.getTaskList()
			},
			getTaskList() {
				var data = {
					isFinish: this.state ? this.state == "1" : null,
					courseId: this.courseId,
					limit: this.limit,
					current: this.taskPage
				}
				tasklist(data).then(res => {
					if(res.code == "OK") {
						this.tasktotalRow = res.data.total;
						this.taskList = res.data.records
					}
				})
			},
		},
	}
</script>